import { Feedback } from "@/components/UploadFeedback/types";
import UploadFeedback from "@/components/UploadFeedback/UploadFeedback";
import { useCreateFeedbackMutation } from "@/hooks/feedback";
import { useCurrentUploadId } from "@/hooks/uploads";
import Button from "@ingka/button";
import Text from "@ingka/text";
import { useState } from "react";
import { useNavigate } from "react-router";

export const UnderReviewPage = () => {
  const navigate = useNavigate();
  const uploadId = useCurrentUploadId();
  const feedbackMutation = useCreateFeedbackMutation();
  const [feedback, setFeedback] = useState<Feedback>({
    rating: 0,
    comment: "",
    allowContact: true,
  });

  return (
    <div className="flex h-[720px] flex-col">
      <div className="center">
        <Text tagName="h2" headingSize="m">
          Upload request submitted!
        </Text>
        <Text tagName="p" className="mb-space150 mt-space200" bodySize="m">
          How was your experience?
        </Text>
        <UploadFeedback feedback={feedback} onFeedback={setFeedback} />
      </div>
      <div className="mb-space250 ml-auto mr-space150 mt-auto">
        <Button
          text="Continue"
          type="emphasised"
          className="w-[164px]"
          onClick={async () => {
            const { rating, comment, allowContact } = feedback;
            if (rating || comment) {
              await feedbackMutation.mutateAsync({
                rating,
                comment,
                uploadId: allowContact ? uploadId : undefined,
              });
            }
            navigate("/overview");
          }}
        />
      </div>
    </div>
  );
};
